// src/game-system/races/human.js
import { BaseRace } from './baseRace';

export const Human = new BaseRace({
  name: "Human",
  description: "Versatile and ambitious, humans are adaptable to any situation",
  attributeBonuses: {
    strength: 1,
    dexterity: 1,
    constitution: 1,
    intelligence: 1,
    wisdom: 1,
    charisma: 1
  },
  traits: [
    {
      name: "Versatile",
      description: "Humans quickly adapt to new situations",
      effect: {
        type: "passive",
        mechanics: "Gain proficiency in one additional skill of your choice"
      }
    }
  ],
  cultures: [
    {
      name: "Merchant Kingdom",
      description: "Raised in a prosperous trading nation",
      bonusSkills: ["Persuasion", "Investigation"],
      startingEquipment: ["Fine clothes", "Trading goods"],
      traditions: [
        {
          name: "Market Wisdom",
          benefit: "Advantage on Charisma checks related to trade"
        }
      ]
    }
  ],
  size: {
    category: "Medium",
    height: { min: 150, max: 190 },
    weight: { min: 50, max: 100 }
  },
  speed: 30,
  languages: {
    known: ["Common"],
    bonus: 1
  }
});